module.exports = __webpack_public_path__ + "media/images/carbon_hospitals/v3/common/icon_time-d58c333662a66fab7313dcc8436a0f98.svg";